module.exports = __webpack_public_path__ + "img/inHouseTrainingSchedule032124.6e3ade1c.jpg";